import { Component, Input } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MarkdownPipe } from '../markdown.pipe';

@Component({
    selector: 'tea-shop-fe-truncated-markdown',
    templateUrl: './truncated-markdown.component.html',
    styleUrl: './truncated-markdown.component.css',
    standalone: true,
    imports: [AsyncPipe, MarkdownPipe]
})
export class TruncatedMarkdownComponent {
  @Input() text : string | null = '';
  @Input() maxLength = 35;
  @Input() inline = false;

  expanded = false;
  
  get fullText(): string {
    return this.text || '';
  }

  get displayText(): string {
    if (!this.text) {
      return '';
    }
    if (this.expanded || this.wordCount <= this.maxLength) {
      return this.text;
    }
    return this.trimmedToWordCount + '...';
  }

  get wordCount(): number {
    return this.text ? this.text.split(/\s+/).length : 0;
  }

  get trimmedToWordCount(): string {
    return this.text ? this.text.split(/\s+/).slice(0, this.maxLength).join(' ') : '';
  }

  toggleExpanded(): void {
    this.expanded = !this.expanded;
  }
}
